import type { MatchMap } from "../model/Analysis";

// Итоги карты для плашек: лагеря, руны и бонусы против союзников, мид-босс.
export type MapFacts = {
  camps: { mine: number; mates: number; missed: number };
  runes: { mine: number; total: number; matesAverage: number };
  pickups: { mine: number; matesAverage: number };
  midBoss: { ours: number; total: number };
};

export const mapFacts = (match: MatchMap): MapFacts => {
  const mates = match.players.filter(
    (player) => player.team === match.team && player.slot !== match.player_slot,
  );
  const average = (count: (slot: number) => number): number =>
    mates.length === 0
      ? 0
      : Math.round(mates.reduce((sum, mate) => sum + count(mate.slot), 0) / mates.length);
  const runesOf = (slot: number): number =>
    match.runes.filter((rune) => rune.taken_by_slot === slot).length;
  // Число бонусов — из счётчика игрока: моменты подбора (точки на карте) есть не во всех матчах.
  const pickupsOf = (slot: number): number =>
    match.players.find((player) => player.slot === slot)?.pickups ?? 0;
  return {
    camps: {
      mine: match.camps.filter((camp) => camp.status === "me").length,
      mates: match.camps.filter((camp) => camp.status === "team").length,
      missed: match.camps.filter((camp) => camp.status === "missed").length,
    },
    runes: {
      mine: runesOf(match.player_slot),
      total: match.runes.length,
      matesAverage: average(runesOf),
    },
    pickups: { mine: pickupsOf(match.player_slot), matesAverage: average(pickupsOf) },
    midBoss: {
      ours: match.mid_boss.filter((kill) => kill.team_claimed === match.team).length,
      total: match.mid_boss.length,
    },
  };
};
